import React, { PropTypes } from 'react';
import Text from 'components/Page/PageComponents/Text/Text';

const Fakta = ({ children }) => {
  const style = require('./Fakta.scss');
  return <Text innerStyle={style.fakta}>{children}</Text>;

};

Fakta.propTypes = {
  children: PropTypes.string
};

export default Fakta;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Page/PageComponents/Fakta/Fakta.js
 **/